import { Switch, Route, Redirect, useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Settings.module.css";
import Footer from "../_shared/Footer/Footer";
import UserSettings from "./User/UserSettings";
import OrganizationSettings from "./Organizations/OrganizationSettings";
import SuperadminFeideOrganizations from "./Organizations/SuperadminFeideOrganizations";
import SuperadminFeideWhitelist from "./Organizations/SuperadminFeideWhitelist";
import { useMySystemRoles } from "../../api/hooks";
import React from "react";

const Settings = () => {
  const { t } = useTranslation("common");
  const location = useLocation();
  const history = useHistory();
  const { data: systemRolesData } = useMySystemRoles();

  const systemRoles = systemRolesData?.data || [];
  const isSystemAdmin = systemRoles.includes("systemadmin");

  const isUserTab = location.pathname === "/settings" || location.pathname === "/settings/user";
  const isOrgTab = location.pathname.startsWith("/settings/organizations");
  const isSuperadminTab = location.pathname === "/settings/superadmin";
  const isSuperadminWhitelistTab = location.pathname === "/settings/superadmin/whitelist";

  return (
    <>

      <Switch>
        <Route exact path="/settings/group/:id/manage" render={() => <Redirect to="/settings/organizations" />} />
        <Route exact path="/settings/group/:id" render={() => <Redirect to="/settings/organizations" />} />
        <Route path="/settings">
          <main className={styles.container}>
            <h1 className={styles.title}>{t("auth.settings.title")}</h1>

            <div className={styles.tabs}>
              <button
                className={`${styles.tab} ${isUserTab ? styles.activeTab : ""}`}
                onClick={() => history.push("/settings/user")}
              >
                {t("auth.settings.tabs.user")}
              </button>
              <button
                className={`${styles.tab} ${isOrgTab ? styles.activeTab : ""}`}
                onClick={() => history.push("/settings/organizations")}
              >
                {t("auth.settings.tabs.organizations")}
              </button>
              {isSystemAdmin && (
                <button
                  className={`${styles.tab} ${isSuperadminTab ? styles.activeTab : ""}`}
                  onClick={() => history.push("/settings/superadmin")}
                >
                  {t("auth.settings.tabs.feideOrgs")}
                </button>
              )}
              {isSystemAdmin && (
                <button
                  className={`${styles.tab} ${isSuperadminWhitelistTab ? styles.activeTab : ""}`}
                  onClick={() => history.push("/settings/superadmin/whitelist")}
                >
                  {t("auth.settings.tabs.feideWhitelist")}
                </button>
              )}
            </div>

            <Switch>
              <Route exact path="/settings" render={() => <Redirect to="/settings/user" />} />
              <Route exact path="/settings/user" component={UserSettings} />
              <Route exact path="/settings/organizations" component={OrganizationSettings} />
              {isSystemAdmin && (
                <Route exact path="/settings/superadmin" component={SuperadminFeideOrganizations} />
              )}
              {isSystemAdmin && (
                <Route exact path="/settings/superadmin/whitelist" component={SuperadminFeideWhitelist} />
              )}
            </Switch>
          </main>
        </Route>
      </Switch>
      <Footer />
    </>
  );
};

export default Settings;
